export default __webpack_public_path__ + "static/media/ok-telecom-black.df0b4ffd.png";